/* Voltage Models — trade interactions
   Animated free-delivery bar, order-by countdown, live line total.
   Defensive: every feature no-ops if its elements are absent. */
(function () {
  'use strict';

  function money(cents) {
    var sym = (window.Shopify && Shopify.currency && Shopify.currency.active === 'USD') ? '$' : '£';
    return sym + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ---------- 1. Free-delivery progress bar ---------- */
  function animateShipBars() {
    document.querySelectorAll('[data-vm-ship]').forEach(function (bar) {
      var fill = bar.querySelector('[data-vm-fill]');
      if (!fill) return;
      var pct = parseFloat(bar.getAttribute('data-vm-pct')) || 0;
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { fill.style.width = pct + '%'; });
      });
    });
  }

  /* ---------- 2. Order-by cutoff countdown ---------- */
  function parseCutoff(str) {
    var m = (str || '').trim().match(/(\d{1,2})(?::(\d{2}))?\s*([ap]m)?/i);
    if (!m) return { h: 15, min: 0 };
    var h = parseInt(m[1], 10);
    var min = m[2] ? parseInt(m[2], 10) : 0;
    var ap = (m[3] || '').toLowerCase();
    if (ap === 'pm' && h < 12) h += 12;
    if (ap === 'am' && h === 12) h = 0;
    return { h: h, min: min };
  }

  function tickCountdowns() {
    document.querySelectorAll('[data-vm-cutoff]').forEach(function (el) {
      var textEl = el.querySelector('.vm-cutoff__text');
      if (!textEl) return;
      var cut = parseCutoff(el.getAttribute('data-vm-cutoff-time'));
      var now = new Date();
      var target = new Date();
      target.setHours(cut.h, cut.min, 0, 0);
      var day = now.getDay();
      var weekend = (day === 0 || day === 6);
      var passed = now > target;

      if (weekend || passed) {
        el.classList.remove('is-urgent');
        textEl.innerHTML = 'Order now — ships ' + (weekend ? 'Monday' : 'next working day') +
          ' (cutoff ' + el.getAttribute('data-vm-cutoff-time') + ')';
        return;
      }

      var diff = Math.max(0, target - now);
      var hrs = Math.floor(diff / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      el.classList.toggle('is-urgent', diff < 3600000);
      var left = (hrs > 0 ? hrs + 'h ' : '') + mins + 'm ' + secs + 's';
      textEl.innerHTML = 'Order within <strong>' + left + '</strong> for next working day delivery';
    });
  }

  /* ---------- 3. Live line total on product page ---------- */
  function wireLineTotals() {
    document.querySelectorAll('[data-vm-trade-panel]').forEach(function (panel) {
      var unit = parseInt(panel.getAttribute('data-vm-unit'), 10) || 0;
      var box = panel.querySelector('[data-vm-linetotal]');
      if (!box) return;
      var form = panel.closest('product-info, .product, section') || document;
      var qtyInput = form.querySelector('.quantity__input, input[name="quantity"]');
      if (!qtyInput) return;

      function update() {
        var q = parseInt(qtyInput.value, 10) || 1;
        var qEl = box.querySelector('[data-vm-qty]');
        var tEl = box.querySelector('[data-vm-total]');
        if (qEl) qEl.textContent = q;
        if (tEl) tEl.textContent = money(unit * q);
        box.hidden = false;
      }
      qtyInput.addEventListener('input', update);
      qtyInput.addEventListener('change', update);
      update();
    });
  }

  function init() {
    animateShipBars();
    wireLineTotals();
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
    initVatToggle();
  }

  /* ---------- 4. ex VAT / inc VAT price toggle ---------- */
  function currentVatMode() {
    var m = document.documentElement.getAttribute('data-vat-mode');
    return m === 'inc' ? 'inc' : 'ex';
  }

  function applyVatMode(mode) {
    document.documentElement.setAttribute('data-vat-mode', mode);
    try { localStorage.setItem('vm-vat-mode', mode); } catch (e) {}

    // swap every dual-value price
    document.querySelectorAll('.vm-amt').forEach(function (el) {
      var v = el.getAttribute(mode === 'inc' ? 'data-inc' : 'data-ex');
      if (v) el.textContent = v;
    });
    // swap every VAT label
    document.querySelectorAll('.vm-vat-label').forEach(function (el) {
      var v = el.getAttribute(mode === 'inc' ? 'data-inc' : 'data-ex');
      if (v) el.textContent = v;
    });
    // reflect button state
    document.querySelectorAll('[data-vm-vat-toggle] [data-vat-mode]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-vat-mode') === mode);
      b.setAttribute('aria-pressed', b.getAttribute('data-vat-mode') === mode ? 'true' : 'false');
    });
  }

  function initVatToggle() {
    var toggle = document.querySelector('[data-vm-vat-toggle]');
    // honour configured default only if the visitor has no saved choice
    var saved = null;
    try { saved = localStorage.getItem('vm-vat-mode'); } catch (e) {}
    var mode = saved || (toggle && toggle.getAttribute('data-vat-default')) || 'ex';
    applyVatMode(mode);

    if (toggle && !toggle.dataset.vmBound) {
      toggle.dataset.vmBound = '1';
      toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-vat-mode]');
        if (!btn) return;
        applyVatMode(btn.getAttribute('data-vat-mode'));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when Dawn re-renders the cart (add to cart, qty change) */
  document.addEventListener('cart-update', function () { setTimeout(function () { animateShipBars(); }, 60); });
  /* re-apply chosen VAT view after Dawn swaps price/section HTML */
  document.addEventListener('cart-update', function () { setTimeout(function () { applyVatMode(currentVatMode()); }, 60); });
  document.addEventListener('variant:change', function () { setTimeout(function () { applyVatMode(currentVatMode()); }, 40); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(animateShipBars, 60); }); } catch (e) {}
  }
  /* Cart drawer opens often without a full event; observe DOM as a fallback */
  var mo = new MutationObserver(function () { animateShipBars(); });
  var drawer = document.querySelector('cart-drawer, #CartDrawer, .drawer');
  if (drawer) mo.observe(drawer, { childList: true, subtree: true });
})();
